// extracted by mini-css-extract-plugin
export var base = "_41-0";
export var updateBanner = "_41-1";